import { action, computed, observable } from 'mobx';
import { apiService } from '@app/utils/api';
import StorageService from '@app/utils/storage';
import { DeviceEnum, getGlobalState } from '@app/utils/getGloabal';
import { ThemesEnum } from '@app/modules/Auth/interfaces';
import { LoginForm, UserInterface } from '../../types/auth';

const authTokenId = '_t';
const usernameKey = 'username';

export default class ModuleStore {
  private storage: StorageService;

  @observable public loadingAuthState = false;
  @observable public userInfo?: UserInterface;
  @observable public device: DeviceEnum = DeviceEnum.DESKTOP;
  @observable public collapsed: boolean = false;
  @observable public locale: string = 'en_US';
  @observable public theme: ThemesEnum = ThemesEnum.LIGHT;

  constructor() {
    this.storage = new StorageService('__');
    this.getGlobalState();
    this.checkUserAuth();
  }

  @computed get isMobile(): boolean {
    const { isMobile } = getGlobalState();
    return isMobile;
  }

  @computed get isUserLoggedIn(): boolean {
    return !!(this.userInfo && this.userInfo.id);
  }

  @action.bound public getGlobalState() {
    const { device, isMobile } = getGlobalState();
    this.device = device;
    this.collapsed = isMobile;
  }

  @action.bound public setTheme(theme: ThemesEnum) {
    this.theme = theme;
  }

  @action.bound public setLocale(key: string) {
    this.locale = key;
  }

  @action.bound public setCollapsed(collapsed: boolean) {
    this.collapsed = collapsed;
  }

  @action.bound private setLoading(status: boolean) {
    this.loadingAuthState = status;
  }

  @action.bound public async checkUserAuth() {
    try {
      this.setLoading(true);

      // const data = (await apiService.getAuthProfile()) as UserInterface;

      const usersData = JSON.parse(localStorage.getItem('___t') || '{}');
      if (usersData && usersData?.access_token && usersData?.id) {
        this.setUserInfo(usersData);
      }
    } finally {
      this.setLoading(false);
    }
  }

  @action.bound public async login(loginForm: LoginForm) {
    try {
      this.setLoading(true);
      // @ts-ignore
      const data = await apiService.postAuthLogin(loginForm);
      this.userInfo = data;
      this.setUserInfo(data);
      this.getGlobalState();
    } finally {
      this.setLoading(false);
    }
  }

  @action.bound private async setUserInfo(data) {
    this.userInfo = data;
    this.storage.set(authTokenId, data);
  }

  @action.bound public removeToken() {
    // @ts-ignore
    this.userInfo = null;
    this.storage.remove(authTokenId);
  }

  @action.bound public async logout() {
    try {
      this.setLoading(true);
      // @ts-ignore
      await apiService.getAuthLogout();
      this.removeToken();
    } finally {
      this.setLoading(false);
    }
  }
}
